import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Services() {
  const { t } = useLanguage();
  const items = t('services.items');

  return (
    <section id="services" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
              {t('services.title')}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              {t('services.desc')}
            </p>
            <a href="#contact" className="text-blue-600 font-semibold hover:text-blue-700 flex items-center gap-2">
              Learn more about our strategy <span aria-hidden="true">&rarr;</span>
            </a>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-gray-50 p-8 rounded-3xl border border-gray-100 shadow-sm"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">{t('services.provideTitle')}</h3>
            <ul className="space-y-4">
              {Array.isArray(items) && items.map((item, idx) => (
                <li key={idx} className="flex items-center text-gray-700 font-medium">
                  <SafeIcon icon={FiCheckCircle} className="text-teal-500 mr-3 text-xl flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

        </div>
      </div>
    </section>
  );
}